import logo from "./logo.svg";
import "./App.css";
import img from "./Images/Rectangle 6667501.png";
import { Route, Routes, BrowserRouter, useNavigate } from "react-router-dom";
import MainLayout from "./MainLayout/MainLayout";
import WinnersHome from "./View/WinnersHome/WinnersHome";
import Footer from "./Layout/Footer";
import PropertyList from "./View/PropertyList/PropertyList";
import Community from "./View/Community/Community";
import WinnersAboutUs from "./View/AboutUs/WinnersAboutUs";
import WinnersAboutUsBlue from "./View/AboutUs/WinnersAboutUsBlue";
import Pricingplans from "./View/Pricing Plans/Pricingplans";
import Career from "./View/Career/Career";
import Profile from "./View/Profile/Profile";
import ListOfFavourites from "./View/PropertyList/ListOfFavourites";
import CommunityList from "./View/Community/CommunityList";
import Blog from "./View/Blog/Blog";
import UserProfile from "./View/Profile/UserProfile";
import EditProfile from "./View/Profile/EditProfile";
import BlogDetails from "./View/Blog/BlogDetails";
import WebPopup from "./Component/WebPopup";
import CommunityFav from "./View/Community/CommunityFav";
import CommunityDetails from "./View/Community/CommunityDetails";
import ActivePropertyList from "./View/PropertyList/ActivePropertyList";
import NewPropertyList from "./View/PropertyList/NewPropertyList";
import DeactivePropertyList from "./View/PropertyList/DeactivePropertyList";
import AboutUs from "./AboutUs/AboutUs";
// import PrivacyPolicy2 from "./AboutUs/PrivacyPolicy";
import PrivacyPolicy from "./PrivacyTerms/PrivacyPolicy"
import TermsAndConditions from "./PrivacyTerms/TermsAndConditions"
import CityPage from "./View/CityPage/CityPage";
import { useEffect, useState } from "react";
import HomeService from "./Services/HomeService";
import SingleProperty from "./View/SingleProperty/SingleProperty";
import Newhome from "./View/WinnersHome/NewHomepage/Newhome";
import NewPropertySingle from "./View/WinnersHome/NewPropertySingle/NewPropertySingle";
import { useDispatch } from "react-redux";
import { getUser } from "./Stores/Slices/AuthSlice";
import NewHome2 from "./View/WinnersHome/NewHome2/NewHome2";
import WinnersLand from "./View/WinnersHome/WinnerLand/WinnerLand";
import WinnerBlueLan from "./View/WinnersHome/WinnerBlueLan/WinnerBlueLan";
import { useTheme, useCountUp } from "./View/WinnersHome/WinnerLand/useTheme";
import { Moon, Sun, Menu, Settings, X } from "lucide-react";
import NewCItypage from "./View/CityPage/NewCItypage";
import NewCitypageBlue from "./View/CityPage/NewCitypageBlue";
import BlogLandingSections from "./View/Blog/BlogLandingSections";
import DeleteAccount from "./PrivacyTerms/DeleteAccount";

function WebPopupWithNavigation() {
  const navigate = useNavigate();
  return <WebPopup navigate={navigate} />;
}

function App() {
  // const { dark, toggle } = useTheme();
  const [userSubscription, setUserSubscription] = useState(false);

  const dispatch = useDispatch();
  const fetchSubscriptionStatus = async () => {
    try {
      const res = await HomeService.userHasActiveSubscriptionOrNot();
      // const res = await HomeService.getRemarks();
      console.log("User Authenticated", res);
      // console.log("User Get Remarks", res);
      if (res?.status) {
        setUserSubscription(res?.hasSubscription);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchSubscriptionStatus();
  }, []);

  // useEffect(() => {
  //   dispatch(getUser());
  // }, []);

  const [scrollPercentage, setScrollPercentage] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const percentage = Math.round((scrollTop / docHeight) * 100);

      setScrollPercentage(percentage);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [dark, setDark] = useState(localStorage.getItem("theme") === "dark");

  const toggle = () => {
    setDark((prev) => !prev);
  };

  // useEffect(() => {
  //   if (dark) {
  //     document.documentElement.classList.add("dark");
  //     localStorage.setItem("theme", "dark");
  //   } else {
  //     document.documentElement.classList.remove("dark");
  //     localStorage.setItem("theme", "light");
  //   }
  // }, [dark]);

  useEffect(() => {
  const savedTheme = localStorage.getItem("theme");

  if (savedTheme === "dark") {
    document.documentElement.classList.add("dark");
    setDark(true);
  } else {
    document.documentElement.classList.remove("dark");
    setDark(false);
  }
}, []);

useEffect(() => {
  localStorage.setItem("theme", dark ? "dark" : "light");

  if (dark) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}, [dark]);

useEffect(() => {
  const handleStorage = (e) => {
    if (e.key === "theme") {
      const isDark = e.newValue === "dark";

      setDark(isDark);

      if (isDark) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }
  };

  window.addEventListener("storage", handleStorage);

  return () => {
    window.removeEventListener("storage", handleStorage);
  };
}, []);

  return (
    <>
      {/* <button
  className="wsh-theme-btn_blue"
  onClick={toggle}
  aria-label="Toggle theme"
>
  {dark ? <Moon size={18} /> : <Settings size={18} />}
</button> */}
      {/* <button
  className={`wsh-theme-btn_blue ${dark ? "theme-dark" : ""}`}
  onClick={toggle}
  aria-label="Toggle theme"
>
  {dark ? <Moon   size={18} /> : <Settings size={18} />}
</button> */}
      <button
        className={`theme-slider-btn ${dark ? "active" : ""}`}
        onClick={toggle}
        aria-label="Toggle Theme"
      >
        <div className="theme-slider-track">
          <div className="theme-slider-thumb">
            {dark ? <Moon size={18} /> : <Settings size={18} />}
          </div>
        </div>
      </button>
      {/* <WebPopup /> */}
      <BrowserRouter>
        {!userSubscription && <WebPopupWithNavigation />}
        <Routes>
          {/* <Route path="/city-page" element={<CityPage />} /> */}
          <Route path="/:cityName" element={<CityPage />} />
          <Route path="/" element={<MainLayout />}>
            {/* <Route path="/" element={<WinnersHome />} /> */}
            <Route path="/oldhome" element={<WinnersHome />} />
            <Route path="/newhome" element={<Newhome />} />
            <Route path="/home" element={<WinnersLand />} />
            <Route path="/" element={<WinnerBlueLan />} />
            <Route path="/bluehome" element={<WinnerBlueLan />} />
            <Route path="/newsingle-property" element={<NewPropertySingle />} />
            <Route path="/city/:newcitypage" element={<NewCItypage />} />
            <Route path="/newcitypageblue" element={<NewCitypageBlue />} />
            <Route path="/aboutusblue" element={<WinnersAboutUsBlue />} />
            <Route path="/blogblue" element={<BlogLandingSections />} />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/delete-account" element={<DeleteAccount />} />


            {/* <Route index element={<WinnersHome />} /> */}
            <Route path="/propertylist" element={<PropertyList />} />
            {/* <Route path="/about-us" element={<AboutUs />} /> */}
            <Route path="/communitylist" element={<Community />} />
            {/* <Route path="/communitylist" element={<CommunityList />} /> */}
            <Route path="/community-details" element={<CommunityDetails />} />
            <Route path="/aboutus" element={<WinnersAboutUs />} />
            
            {/* <Route path="/privacy-policy2" element={<PrivacyPolicy2 />} /> */}
            <Route path="/pricingplan" element={<Pricingplans />} />
            <Route path="/career" element={<Career />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/list-of-favourites" element={<ListOfFavourites />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog-details" element={<BlogDetails />} />
            {/* <Route path='/user-profile' element={<UserProfile/>}/> */}
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/community-fav-list" element={<CommunityFav />} />
            <Route path="/active-properties" element={<ActivePropertyList />} />
            <Route path="/new-properties" element={<NewPropertyList />} />
            <Route path="/single-property" element={<SingleProperty />} />
            <Route
              path="/deactive-properties"
              element={<DeactivePropertyList />}
            />
          </Route>
        </Routes>
      </BrowserRouter>

      {/* <div
        id="scroll-percentage"
        className={`scroll-progress ${scrollPercentage > 5 ? "active" : ""}`}
        onClick={scrollToTop}
      >
        <span>{scrollPercentage >= 96 ? "↑" : `${scrollPercentage}%`}</span>
      </div> */}

      <div
        id="scroll-percentage"
        className={`scroll-progress ${scrollPercentage > 5 ? "active" : ""}`}
        onClick={scrollToTop}
        style={{
          "--progress": `${scrollPercentage * 3.6}deg`,
        }}
      >
        <span>
          {scrollPercentage >= 96 ? "↑" : `${scrollPercentage}%`}
        </span>
      </div>
    </>
  );
}

export default App;
